module.exports = __webpack_public_path__ + "static/assets/0c19152025f432ddd7d67c039d328f26.svg";